export default __webpack_public_path__ + "assets/uv-index-9.75be40aa.svg";